import React from "react";

import { ISectionProps, Section } from "@/eworkitComponents";

interface IDetailSectionProps extends ISectionProps {}

export const DetailSection: React.FunctionComponent<IDetailSectionProps> = ({ children, ...sectionProps }) => (
  // TODO - div to fix size problems
  <div>
    <Section innerMargin="sm" {...sectionProps}>
      {children}
    </Section>
  </div>
);
